import { ExploreRouteFragment } from '../../../../generated/models';

export enum ZoomLevel {
  mid = 'mid',
  top = 'top',
}
export interface IExploreMapProps {
  routes: ExploreRouteFragment[];
}
